import type { RequestFormMode } from "@RequestFormV2/context/requestFormMode";

type PaymentLocationDetailsParams = {
  location: string;
  form: "v2";
  shipment_draft_reference?: string;
  quick_request_draft_reference?: string;
};

export function getPaymentLocationDetailsParams(
  kind: RequestFormMode,
  location: string,
  draftId?: string | null,
): { isQuote: boolean; params: PaymentLocationDetailsParams } {
  const params: PaymentLocationDetailsParams = {
    location,
    form: "v2",
    ...(draftId &&
      (kind === "quick"
        ? { quick_request_draft_reference: draftId }
        : { shipment_draft_reference: draftId })),
  };

  return {
    isQuote: kind === "quote",
    params,
  };
}
